<template>
    <div class="surmise content-view">
        <!-- header menus -->
        <menus />

        <!-- title & desc -->
        <h2 class="fs-24 text-center fc-theme paddingT-20">{{ infoData[path].title }}</h2>
        <p class="subtitle text-center fs-14 fc-666">{{ infoData[path].desc }}</p>

        <!-- price -->
        <top-price ref="topPriceRef" :code="infoData[$route.path].priceName" first-flow="1"></top-price>

        <div class="padding-20">
            <!-- content -->
            <el-form class="marginT-50 mobile-form" :label-width="path == '/checkNum/similarImport' ? '160px' : '120px'">
                <!-- 买家秀是传买家秀 ID, 不需要商品链接以及商品关键词  -->
                <div v-if="path !== '/head_screen/buyers-show'">
                    <el-form-item v-if="path == '/head_screen/firstPause'" label="关键词：">
                        <el-input v-model="form.keyword" placeholder="请输入您的关键词"></el-input>
                    </el-form-item>

                    <el-form-item v-if="path == '/checkNum/similarImport'" label="商品标题（可不填）：">
                        <el-input v-model="form.keyword" placeholder="请输入商品全标题（可不填）"></el-input>
                    </el-form-item>
                    
                    <el-form-item :label="logSuffix==46?'视频ID：' : '商品链接：'">
                        <el-input v-model="form.url" :placeholder="logSuffix==46 ? '请输入视频ID':'请输入您的商品链接'"></el-input>
                    </el-form-item>
                </div>

                <!-- 买家秀 -->
                <div v-else>
                    <el-form-item label="买家秀ID：">
                        <el-input v-model="form.buyers_id" placeholder="请输入您的买家秀ID"></el-input>
                    </el-form-item>
                </div>

                <!-- 生活研究所 额外表单 -->
                <el-form-item v-if="path === '/head_screen/life'" label="人群标签（人群类型选择）：">
                    <el-cascader
                        v-model="form.label"
                        :options="crowdType"
                        style="width: 100%"
                        :show-all-levels="false"
                    ></el-cascader>
                </el-form-item>

                <!-- 手淘旺旺 额外表单 -->
                <el-form-item v-if="path === '/head_screen/wangwang'" label="掌柜旺旺：">
                    <el-input v-model="form.wangwang" placeholder="请输入掌柜旺旺"></el-input>
                </el-form-item>

                <el-form-item v-if="path === '/head_screen/wangwang'">
                    <p style="color: #f00;">注：输入要卡的掌柜旺旺</p>
                </el-form-item>

                <!-- 手淘其它商品详情页 -->
                <div v-if="path==='/head_screen/other-shop' || path==='/tbmobile/tm-neighbor-goodies'">
                    <el-form-item label="竞品ID-1：">
                        <el-input v-model="form.main_url1" placeholder="请输入竞品ID-1"></el-input>
                    </el-form-item>

                    <div v-if="path==='/head_screen/other-shop'">
                        <el-form-item label="竞品ID-2：">
                            <el-input v-model="form.main_url2" placeholder="请输入竞品ID-2"></el-input>
                        </el-form-item>

                        <el-form-item>
                            <p style="color: #888;">注意：其他商品详情来源=非淘宝详情页来源，其他商品详情页来源 是淘宝过去未定义的流量来源统称</p>
                        </el-form-item>
                    </div>
                </div>

                <!-- 淘内免费其它通用版 -->
                <el-form-item v-if="path === '/head_screen/other-fee'">
                    <p style="color: #f00;">注：苹果（iOS）淘宝版本10.1.10以上无效，安卓都支持</p>
                </el-form-item>

                <!-- 支付页-猜你喜欢-流量来源手淘推荐 -->
                <el-form-item v-if="path === '/head_screen/buy-page'">
                    <p style="color: #f00;">提示：二维码只支持安卓手机打开</p>
                </el-form-item>

                <!-- 高权重 搜索卡首屏 -->
                <el-form-item v-if="path === '/head_screen/firstPause'">
                    <p style="color: #f00;">注意：其他商品详情来源=非淘宝详情页来源，其他商品详情页来源 是淘宝过去未定义的流量来源统称</p>
                </el-form-item>

                <!-- 卡首屏系列 btn -->
                <el-form-item v-if="typeNumber">
                    <el-badge :value="infoData[path].freeForMembers ? '会员免费' : '会员更优惠'" class="item">
                        <el-button type="danger" @click="getQrcodeFirst">点击生成二维码</el-button>
                    </el-badge>
                </el-form-item>

                <!-- 高权重 搜索卡首屏 btn -->
                <el-form-item v-else-if="path === '/head_screen/firstPause'">
                    <el-badge :value="infoData[path].freeForMembers ? '会员免费' : '会员更优惠'" class="item">
                        <el-button type="danger" @click="getQrcodeFirstPause">点击生成二维码</el-button>
                    </el-badge>
                </el-form-item>

                <!-- 手淘卡屏系列 btn -->
                <el-form-item v-else>
                    <el-badge :value="infoData[path].freeForMembers ? '会员免费' : '会员更优惠'" class="item">
                        <el-button type="danger" @click="getQrcode">{{ userData.is_vip ? '一键生成' : '点击生成' }}</el-button>
                    </el-badge>
                    <el-button type="info" class="item" plain @click="getQrcode('tkl')">点击生成淘口令</el-button>
                </el-form-item>
            </el-form>

            <!-- 展示淘口令 -->
            <tklShow v-if="tklData.password" :password="tklData.password"></tklShow>

            <!-- 二维码 -->
            <p v-if="showPt" style="padding-left: 110px;">该商品不支持高级版，已经生成普通版的卡首屏码</p>
            <div v-show="showQr" class="showqrcode flex">
                <div class="qrcode" ref="qrcode" id="qrcode"></div>
            </div>

            <!-- 二维码和淘口令 record -->
            <qrRecord ref="qrRecord" v-show="logType === 'qrcode'" :typeNumber="logName" :manual-init="true"></qrRecord>
            <tklRecord ref="record" v-show="logType !=='qrcode'" :method="logName" tableColType="mobileUrl" :manual-init="true"></tklRecord>

            <!-- tips -->
            <!-- mechanism -->
            <div v-show="logSuffix < 32" class="tip-card marginT-50">
                <intro :pricePreMonth="pricePreMonth"></intro>
            </div>
        </div>
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import { mapState } from 'vuex'
import Menus from './_components/Menus'
import { infoData } from './config'
import { crowdType } from './crowd'
import tklShow from '@/index/components/tklShow'
import tklRecord from '@/index/components/tklRecord'
import qrRecord from '@/index/components/qrRecord'
import intro from './intro'

export default {
    components: {
        tklShow,
        tklRecord,
        qrRecord,
        Menus,
        intro
    },
    data() {
        return {
            infoData, // 配置数据
            crowdType, // 人群标签配置
            form: {
                keyword: undefined,
                url: undefined,
                label: undefined, // 生活研究所 额外标签
                wangwang: undefined, // 手淘旺旺
                main_url1: undefined, // 竞品 ID 1
                main_url2: undefined, // 竞品 ID 2
                buyers_id: undefined, // 买家秀 ID
            },
            tklData: {
                password: ''
            },
            showQr: false,
            showPt: false,
            invokeName: "", // 淘口令和二维码日志需要的参数
            logName: "", // 淘口令和二维码日志需要的参数
            logSuffix: 0,   // cardFirstScreen+数字类型的，获取其数字部分
            logType: "", // log 是生成记录, qrcode 是二维码生成记录
            typeNumber: undefined, // 只展示二维码日志需要的参数, 从 invokeName 内截取而来, 存在则表示是卡首屏系列
            pricePreMonth: {},
        }
    },
    computed: {
        ...mapState(['userData', 'phone', 'configData']),
        path() {
            return this.$route.path
        }
    },
    watch: {
        $route(to, from) {
            Object.keys(this.form).forEach(item => {
                this.form[item] = undefined
            })
            this.tklData = {password: ""}
            this.showQr = false;
            this.invokeName = ""
            this.typeNumber = undefined
            this.handleInvokeName()
            this.priceLimit()
            this.$refs.topPriceRef.priceLimit()
            this.$refs.topPriceRef.getPackagePrice()

            this.logName = this.infoData[to.path].logName;
            this.logType = this.infoData[to.path].logType;
        }
    },
    created() {
        // 处理日志的 invokeName
        this.$nextTick(() => {
            this.handleInvokeName()
        })
        
    },
    mounted() {
        // 处理价格显示
        this.priceLimit()
    },
    methods: {
        // 处理日志的 invokeName
        handleInvokeName() {
            let invokeName = this.infoData[this.$route.path].invokeName;
            let qrSplitText = "cardFirstScreen-type";

            // 微详情特殊处理, 返回 typeNumber
            if (this.path === "/head_screen/micro-details") {
                this.typeNumber = invokeName
            }

            // 只展示二维码日志
            if (invokeName.includes(qrSplitText)) {
                this.typeNumber = +invokeName.split(qrSplitText)[1]
            }

            this.invokeName = invokeName;

            this.logName = this.infoData[this.$route.path].logName;
            this.logType = this.infoData[this.$route.path].logType;

            let chkStr = 'cardFirstScreen'
            if (this.logName.includes(chkStr)) {
                this.logSuffix = this.logName.substring(chkStr.length)
            }
            
            this.$refs.qrRecord && this.$refs.qrRecord.init(this.logName)
        },

        // 卡首屏点击生成二维码
        async getQrcodeFirst() {
            // 微详情单独处理
            if (this.path === "/head_screen/micro-details") {
                this.getQrcodeMicroDetails()

                return
            }

            this.showQr = false
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }

            if (!this.form.url) {
                // 买家秀不用验证商品链接或ID
                if (this.path !== "/head_screen/buyers-show") {
                    if (this.logSuffix==46) {
                        this.$message.error('请输入视频ID')
                    } else {
                        this.$message.error('请输入商品链接或ID')
                    }
                    
                    return
                } else if (!this.form.buyers_id) {
                    this.$message.error('请输入买家秀ID')
                    return
                }
            }

            // 生活研究所
            if (this.path === '/head_screen/life' && !this.form.label) {
                this.$message.error('请输入完整')
                return
            }

            // 手淘旺旺
            if (this.path === "/head_screen/wangwang" && !this.form.wangwang) {
                this.$message.error("请输入掌柜旺旺")
                return
            }

            if (this.path == "/tbmobile/tm-neighbor-goodies" && !this.form.main_url1) {
                this.$message.error("请输入竞品ID")
                return
            }

            // 手淘其它商品详情页
            if (this.path === "/head_screen/other-shop" && !this.form.main_url1 && !this.form.main_url2) {
                this.$message.error("请输入竞品ID")
                return
            }

            // 如果是链接形式则判断是否有 id
            if (this.form.url && this.form.url.indexOf('http') > -1 && this.form.url.indexOf('id') === -1) {
                this.$message.error('商品链接错误');
                return false;
            }

            let id = this.form.url;
            try {
                // 如果是链接, 则 ID 从链接里面获取
                if (this.form.url && this.form.url.indexOf('http') > -1) {
                    id = this.getQueryVariable(new URL(this.form.url.replace(/ /g, '')), 'id');
                }
            } catch (e) {
                this.$message.error("请输入正确的商品链接")
                return false;
            }

            window.checkDiscountPackage(this.infoData[this.$route.path].priceName)


            let uploadData = {
                url: id,
                ori_url: this.form.url,
                type: this.typeNumber,
                label: this.form.label && this.form.label[1],
                keyword: this.form.keyword,
                wangwang: this.form.wangwang,
                main_url1: this.form.main_url1,
                main_url2: this.form.main_url2,
                buyers_id: this.form.buyers_id,
            }

            const res = await this.$fetch('/api/proxy/web/' + this.infoData[this.$route.path].priceName, uploadData, 'post');
            if(res.code === 0) {
                this.showQr = true
                this.qrcode(res.data);
                setTimeout(() => {
                    this.$refs.qrRecord.searchSubmit()
                }, 200)
            }
        },

        // 点击手淘卡屏生成二维码
        async getQrcode(isTkl) {
            if (isTkl === 'tkl') {
                this.$message.warning('淘口令维护中')

                return false
            }

            this.showQr = false
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }

            if (!this.form.url) {
                this.$message.error('请输入完整')
                return
            }

            // 如果是链接形式则判断是否有 id
            if (this.form.url.indexOf('http') > -1 && this.form.url.indexOf('id') === -1) {
                this.$message.error('商品链接错误');
                return false;
            }

            let uploadData = {
                url: this.form.url,
                keyword: this.form.keyword
            }

            // 如果是链接, 则 ID 从链接里面获取
            try {
                if (this.form.url.indexOf('http') > -1) {
                    uploadData.url = this.getQueryVariable(new URL(this.form.url.replace(/ /g, '')), 'id');
                }
            } catch (e) {
                this.$message.error("请输入正确的商品链接")
                return false;
            }

            if (isTkl === 'tkl') {
                uploadData.invoke_method = this.infoData[this.path].invokeName;
                uploadData.is_password = true;
            }

            window.checkDiscountPackage(this.infoData[this.path].priceName)

            try {
                const data = await this.$fetch(`/api/proxy/web/${this.infoData[this.path].priceName}`, uploadData, 'post')
                if (data.code == 0) {
                    this.$refs.record.searchSubmit()
                    if (isTkl == 'tkl') {
                        this.tklData = { password: data.data.result_data.password }
                        return
                    }
                    this.showQr = true
                    this.qrcode(data.data.url)
                    this.$store.dispatch('upDateUser')
                }
            } finally {

            }

        },

        // 点击生成微详情二维码
        async getQrcodeMicroDetails() {
            this.showQr = false
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }

            if (!this.form.url) {
                this.$message.error('请输入完整')
                return
            }

            // 如果是链接形式则判断是否有 id
            if (this.form.url.indexOf('http') > -1 && this.form.url.indexOf('id') === -1) {
                this.$message.error('商品链接错误');
                return false;
            }

            let id = this.form.url;
            try {
                // 如果是链接, 则 ID 从链接里面获取
                if (this.form.url.indexOf('http') > -1) {
                    id = this.getQueryVariable(new URL(this.form.url.replace(/ /g, '')), 'id');
                }
            } catch (e) {
                this.$message.error("请输入正确的商品链接")
                return false;
            }

            let uploadData = {
                url: id
            }

            window.checkDiscountPackage(this.infoData[this.$route.path].priceName)
            const res = await this.$fetch('/api/proxy/web/' + this.infoData[this.$route.path].priceName, uploadData, 'post');
            if(res.code === 0) {
                this.showQr = true
                this.qrcode(res.data);
                setTimeout(() => {
                    this.$refs.qrRecord.searchSubmit()
                }, 200)
            }
        },

        // 高权重搜索卡首屏 生成二维码
        async getQrcodeFirstPause() {
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }
            if (!this.form.keyword || !this.form.url) {
                this.$message.error('请输入完整')
                return
            }

            window.checkDiscountPackage("firstScreen")

            const shopInfo = await this.getShopInfo()

            let url = '/api/proxy/web/' + this.infoData[this.$route.path].priceName
            const data = await this.$fetch(url, {...this.form, invoke_method: 'firstScreen', data_json: typeof(shopInfo) === 'string' ? shopInfo : JSON.stringify(shopInfo)}, 'post')
            this.showPt = false;
            // 处理不支持高级版的情况
            if (+data.code === 0 && data.msg === "该商品不支持高级版") {
                this.showPt = true;
                this.$alert('该商品不支持高级版，已经生成普通版的卡首屏码', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {}
                });
            }

            if (+data.code === 0) {
                this.showQr = true
                const skuData = data.data.replace(/ /g, '')
                this.qrcode(skuData)
                this.$refs.record.searchSubmit()
            }
        },

        // 生成二维码
        qrcode(data) {
            if (this.$refs.qrcode) {
                this.$refs.qrcode.innerHTML = ''
            }

            new QRCode('qrcode', {
                width: 300,
                height: 300,
                text: data,
                correctLevel: QRCode.CorrectLevel.L,
                // correctLevel: 3
            })
            this.$refs.qrcode.removeAttribute('title')
            setTimeout(() => {
                this.$refs.qrcode.removeAttribute('title')
            }, 100)
        },

        // 处理价格
        async priceLimit() {
            // todo: TopPrice 组件也在调这个函数，需要解决重复调用问题
            const data = await this.$fetch('/api/proxy/web/tool/detail', { name: this.infoData[this.$route.path].priceName })
            this.pricePreMonth = data.data
        },

        async getShopInfo() {
            return new Promise(async (resolve, reject) => {
                let result = 'test';

                // TODO: 这里暂时返回 test 不再请求淘宝接口
                resolve(result);
                return 0;

                let id = undefined
                try {
                    // 如果是链接, 则 ID 从链接里面获取
                    if (this.form.url.indexOf('http') === 0) {
                        id = this.getQueryVariable(new URL(this.form.url), 'id')
                    } else {
                        id = this.form.url
                    }
                } catch (e) {
                    this.$message.error("请输入正确的商品链接")
                    return false;
                }

                try {
                    let res = await this.$fetch(`https://acs.m.taobao.com/h5/mtop.taobao.detail.getdetail/6.0/?AntiCreep=true&H5Request=true&type=jsonp&dataType=jsonp&data=%7B%22itemNumId%22%3A%22${id}%22%7D`, {}, 'get')

                    // 正常返回数据
                    if (res && res.data && res.data.skuBase) {
                        result = res;
                    }
                } catch (e) {
                    // 这里接收报错信息, 防止因为淘宝接口报错导致程序中断
                    // 获取商品信息的接口里面报错不处理
                }
                resolve(result);
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.showqrcode {
    align-items: flex-end;
    justify-content: center;
}

.box-card {
    margin-top: 25px;

    .li-content {
        line-height: 24px;
        color: #999;
    }
}

.qrcode {
    margin: 10px 30px;
}

.item + .item {
    margin-left: 20px;
}
</style>
<style lang="scss">
.item {
    .el-badge__content.is-fixed {
        right: 0;
        top: 0;
        transform: translateY(-50%) translateX(50%)
    }
}
</style>
